<div class="header-container">
  <button
    class="menu-toggle"
    type="button"
    [attr.aria-label]="'common.toggleMenu' | translate"
    (click)="menuToggle.emit()"
  >
    <span></span>
    <span></span>
    <span></span>
  </button>

  <div class="lang-switch" role="group" [attr.aria-label]="'common.languageAria' | translate">
    <button
      *ngFor="let lang of languages"
      type="button"
      class="lang-switch__btn"
      [class.is-active]="isLanguageActive(lang.code)"
      [attr.aria-pressed]="isLanguageActive(lang.code)"
      (click)="setLanguage(lang.code)"
    >
      {{ lang.labelKey | translate }}
    </button>
  </div>

  <div class="store-name">
    <img *ngIf="header.logoUrl" [src]="header.logoUrl" alt="" />
    <div class="store-name__text">
      <div class="store-name__title">{{ header.title }}</div>
      <div class="store-name__subtitle" *ngIf="header.subtitle">{{ header.subtitle }}</div>
    </div>
  </div>
</div>
